import React from 'react';
import { type PricingRules } from '@gql/schema';
import {
  DiscountBadge,
  DiscountBadgeVariant,
  type IPriceValueTranslationData,
} from '@secretescapes/cauldron';
import { TooltipPosition } from '@secretescapes/falcon';
import { useApplicationState } from '@utils/useApplicationState';
import { Container, StyledDiscountBadge, StyledPriceValue } from './PricesContainer.styles';

export type Rules = Omit<PricingRules, 'showUrgentDiscount | showPrices'>;

interface Pricing {
  leadRate: string;
  rackRate: string;
}

interface Discount {
  price: string;
  tooltip: string | undefined;
}

export interface NavPricesContainerProps {
  rules: Rules;
  pricing: Pricing;
  discount: Discount;
  translationData: IPriceValueTranslationData;
}

export const NavPricesContainer = ({
  rules,
  pricing,
  discount,
  translationData,
}: NavPricesContainerProps) => {
  const { showDiscount, showRackRate } = rules;
  const { leadRate, rackRate } = pricing;
  const { price: discountPrice, tooltip: discountTooltip } = discount;
  const { isMobile } = useApplicationState();

  return (
    <Container isMobile={!!isMobile}>
      <StyledPriceValue
        leadRate={leadRate}
        showRackRate={!!showRackRate}
        rackRate={rackRate}
        showTooltip={translationData.leadRateTooltip.trim().length > 0}
        tooltipPosition={TooltipPosition.bottom}
        translationData={translationData}
      />
      {!!showDiscount && (
        <StyledDiscountBadge>
          <DiscountBadge
            discountPrice={discountPrice}
            variant={DiscountBadgeVariant.default}
            discountTooltip={discountTooltip}
            showTooltip={!!discountTooltip}
          />
        </StyledDiscountBadge>
      )}
    </Container>
  );
};
